export enum EMPCEType {
    "Absence de confinement de la zone",
    "Confinement statique",
    "Confinement dynamique (entre 6 et 10 volumes/h)",
    "Confinement dynamique (entre 10 et 20 volumes/h)",
}